var gsap = require('gsap'),
	common = require('../base/common'),
	emitter = require('../base/emitter');

require('../../vendors/gsap/src/uncompressed/plugins/ScrollToPlugin');
require('../../vendors/gsap/src/uncompressed/plugins/DrawSVGPlugin');

function Scroller(){

	var self = this;

	$(document).on('click', '[data-scrolltop]', function(e){
		e.preventDefault();
		TweenLite.to(window, 1, {scrollTo:{y:0}, ease:Power3.easeInOut});
	})

	$(document).on('click', '[data-scrollto]', function(e){
		e.preventDefault();
		TweenLite.to(window, 1, {scrollTo:{y:0}, ease:Power3.easeInOut});
	})

	$(document).on('click', '[data-scrollto]', function(e){
		e.preventDefault();
		var target = $(this).data('scrollto'),
			$target = $(target);

		if($target.length > 1)
			$target = $target.eq(0);

		TweenLite.to(window, 1, {scrollTo:{y: $target.offset().top }, ease:Power3.easeInOut});
	})

	if(!Modernizr.touchevents){
		common.$window.on('scroll', function(){
			var scrollTop = $(window).scrollTop(),
				scrollTotal = scrollTop + common.screen.height;
			$('[data-image]').each(function(){
				var $item = $(this),
					offset = $item.offset().top,
					height = $item.height(),
					width = $item.width();

				if(scrollTotal * 1.1 >= offset){

					var newHeight = height - (scrollTotal - offset);
					if(newHeight >= 0){
						TweenLite.to($item,0.6,{
							'clip': 'rect('+newHeight+'px, '+width+'px, '+height+'px, 0px)',
						})

					}

				}

			})
			$('[data-scroll]').each(function(){
				var $item = $(this),
					offset = $item.offset().top,
					height = $item.height(),
					width = $item.width();

				if(scrollTotal >= offset & scrollTop < offset + height){

					var move = offset + height * 0.5 - scrollTotal + common.screen.height * 0.6

					if(scrollTop + common.screen.height * 0.5 > offset + height * 0.5){
						TweenLite.to($item,1,{
							y: move * 0.1
						})
					}else{
						TweenLite.to($item,1,{
							y: move * 0.1
						})
					}

					// frizione
					// if(scrollTop + common.screen.height * 2 > offset){
					// 	console.log('prima metà')
					// }else{
					// 	console.log('seconda metà')
					// }


				}

			})

			$('[data-scrollview]').each(function(){
				var $item = $(this),
					offset = $item.offset().top,
					height = $item.height(),
					width = $item.width(),
					value = $item.data('scrollview') != '' ? $item.data('scrollview') : 0.9;

				if(!$item.hasClass('_view') && scrollTop + common.screen.height * value >= offset){
					$item.addClass('_view');
				}

			})

			$('[data-svgdraw]').each(function(){
				var $item = $(this),
					offset = $item.offset().top,
					value = $item.data('svgdraw') != '' ? $item.data('svgdraw') : 0.9;

				if(!$item.hasClass('_view') && scrollTop + common.screen.height * value >= offset){
					$item.addClass('_view');

					var $shapes = $item.children();
					TweenMax.staggerTo($shapes, 0.6, {drawSVG: "100%"},0.1)

				}

			})

		})

		emitter.on('page:loaded', function(){
			self.prepare();
		})

		emitter.on('page:resize', function(){
 			self.prepare();
		})

		if($('.o-product-list').length){

			common.$window.on('mousemove', function(e){

				$('.o-product-list').each(function(){

					var $item = $(this);
					var $itemImage = $item.find('.primo-piano');

					var fattore = $item.closest('.grid').hasClass('grid--right') ? -1 : 1;

					if($itemImage.length && $item.offset().top > common.$window.scrollTop() &&  $item.offset().top <  common.$window.scrollTop() + common.screen.height){

						var pageY = 0;
						if(e.pageY > $itemImage.offset().top){
							
							pageY = (0.5 - Math.abs(e.pageY / $itemImage.offset().top )) * 2;

						}else{

							pageY = (0.5 - Math.abs(e.pageY / $itemImage.offset().top )) * 2 - 1;

						}


						if(e.pageX <= common.screen.width * 0.5){
							
							var perc = (0.5 - Math.abs(e.pageX / common.screen.width)) * 2;
							TweenLite.to($itemImage, 1, { x: -(fattore * 20 * perc), y: pageY })

						}else{

							var perc = (Math.abs(e.pageX / common.screen.width)) * 2 - 1;
							TweenLite.to($itemImage, 1, { x: (fattore * 20 * perc), y: -pageY })

						}


					}


					// if(
					// 	(e.pageX >= $item.offset().left && e.pageX < $item.offset().left + $item.width()) &&
					// 	(e.pageY >= $item.offset().top && e.pageY < $item.offset().top + $item.height())
					// 	){

					// 	if(e.pageX <= $item.offset().left + $item.width() * 0.5){
							
					// 		var perc = (0.5 - Math.abs(e.pageX / common.screen.width)) * 2;
					// 		TweenLite.to($itemImage, 0.3, { x: -(30 * perc) })

					// 	}else{

					// 		var perc = (Math.abs(e.pageX / common.screen.width)) * 2 - 1;
					// 		TweenLite.to($itemImage, 0.3, { x: (30 * perc) })

					// 	}

					// }

				})

			})

		}


	}

	$('[data-image]').on('show', function(){

		var $item = $(this),
			width = $item.width(),
			height = $item.height();

		TweenLite.to($item,0.6,{
			'clip': 'rect(0px, '+width+'px, '+height+'px, 0px)',
			ease: Power3.easeInOut
		})

	})


}

Scroller.prototype.prepare = function(){

	var self = this;
	var scrollTotal = $(window).scrollTop();

	$('[data-image]').each(function(index){

		var $item = $(this),
			$parent = $item.parent(),
			width = $item.width(),
			height = $item.height(),
			offset = $item.offset().top;

		$item.removeAttr('style');
		$parent.removeAttr('style');

		setTimeout(function(){

			$item.css({
				'position': 'absolute',
				'width': width,
				'height': height,
				'clip': 'rect('+height+'px, '+width+'px, '+height+'px, 0px)'
			})

			$parent.css({
				'height': height,
				'position': 'relative'
			});


			if(offset >= scrollTotal && offset + height < scrollTotal + common.screen.height){

				if($item.find('img').attr('src') == 'assets/images/chi-siamo/chi-siamo1.jpg'){

					console.log('dentro');

				}

				TweenLite.to($item, 0.6,{
					'clip': 'rect(' + 0 + 'px, ' + width + 'px, ' + height + 'px, 0px)',
				})

			}
			
		},10)

	})

	$('[data-svgdraw]').each(function(){

		var $item = $(this);

		var $shapes = $item.children();
		TweenLite.set($shapes,{drawSVG:"0%"});

	})

	$(window).trigger('scroll');

}

module.exports = Scroller;


/** WEBPACK FOOTER **
 ** ./components/scroller.js
 **/